export const WORKCARDS_DOWNLOADED = "The workcards have been successfully downloaded. Check your downloads folder to access them.";